import { Component, OnInit } from '@angular/core';
import { LoadingController } from '@ionic/angular';
import { environment } from '../../../environments/environment';
import { HelperService } from '../../services/helper.service';
import { SupaService } from '../../services/supa.service';
import {decode} from 'base64-arraybuffer';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.scss'],
})
export class SettingsComponent implements OnInit {

  loadingDone = false;

  id=null;
  reddays = 5;
  amberdays = 30;
  lang1name = 'English';
  lang1code = 'EN';
  lang2enabled = true;
  lang2name = 'Arabic';
  lang2code = 'AR';
  lang1currency = '€';
  lang2currency = '€';
  defaulttax = 0.21;
  maxtimepre = 20
  maxtimempi = 20
  maxtimejp = 20
  maxtimeauth = 20
  maxtimeqi = 20
  maxtimeprejp = 20
  maxtimepreauth = 20

  videocalls = 'disable';

  externalconfigs = new BehaviorSubject<undefined|ExternalConfig[]>(undefined);
  currentindex = new BehaviorSubject<number>(-1);
  externalconfig = 2;

  helpurl='https://www.youtube.com/embed/shkbe-uQDHo';

  newLogo=undefined;

  constructor(private helper: HelperService, private supa: SupaService, private loadingController: LoadingController) { }

  cacheSettings() {
    localStorage.setItem('SETTINGSEXPIRETIME', (Date.now() + environment.SettingsExpiretime).toString());
    localStorage.setItem('SETTINGS', JSON.stringify({
      id: this.id,
      reddays: this.reddays,
      amberdays: this.amberdays,
      lang1name: this.lang1name,
      lang1code: this.lang1code,
      lang2enabled: this.lang2enabled,
      lang2name: this.lang2name,
      lang2code: this.lang2code,
      lang1currency: this.lang1currency,
      lang2currency: this.lang2currency,
      defaulttax: this.defaulttax,
      videocalls: this.videocalls,
      externalconfig: this.externalconfig,
      maxtimepre: this.maxtimepre,
      maxtimempi: this.maxtimempi,
      maxtimejp: this.maxtimejp,
      maxtimeauth: this.maxtimeauth,
      maxtimeqi: this.maxtimeqi,
      maxtimeprejp: this.maxtimeprejp,
      maxtimepreauth: this.maxtimepreauth,
    }));
  }

  ngOnInit() {
    this.loadData();

    this.supa.supabase.from('externalconfig').select().order('id').then(v => {
      this.externalconfigs.next(v.data);
      this.setIndex();
    });
  }

  setIndex() {
    this.currentindex.next(this.externalconfigs.value.findIndex(d => d.id === this.externalconfig));
  }

  setConfig(id) {
    this.externalconfig = id;
    this.setIndex();
  }

  async onSave() {
    this.loadingDone = false;
    const loading = await this.loadingController.create({
      message: 'Saving the new settings',
      spinner: 'bubbles'
    });
    await loading.present();

    let stop = false;
    console.log('Saving configs');
    this.externalconfigs.value.forEach(async (b, i) => {
      console.log('Saving config ' + (i + 1) + ' / ' + (this.externalconfigs.value.length));
      const res = await this.supa.supabase.from('externalconfig').update(b).eq('id', b.id);
      if (res.error) {
        console.log(res.error);
        stop = true;
        return;
      }
    });
    if (stop) {
      this.helper.notify('Could not save the external config settings', 'warning');
      loading.dismiss();
      return;
    }
    localStorage.removeItem('EXTCONF');

    const saveResult = await this.supa.supabase.from('settings').update({
      reddays: this.reddays,
      amberdays: this.amberdays,
      lang1name: this.lang1name,
      lang1code: this.lang1code,
      lang2enabled: this.lang2enabled,
      lang2name: this.lang2name,
      lang2code: this.lang2code,
      lang1currency: this.lang1currency,
      lang2currency: this.lang2currency,
      defaulttax: this.defaulttax,
      videocalls: this.videocalls,
      externalconfig: this.externalconfig,
      maxtimepre: this.maxtimepre,
      maxtimempi: this.maxtimempi,
      maxtimejp: this.maxtimejp,
      maxtimeauth: this.maxtimeauth,
      maxtimeqi: this.maxtimeqi,
      maxtimeprejp: this.maxtimeprejp,
      maxtimepreauth: this.maxtimepreauth,
    }).eq('id', this.id).single();

    if (!saveResult.error) {
      this.reddays = saveResult.data.reddays;
      this.amberdays = saveResult.data.amberdays;
      this.lang1name = saveResult.data.lang1name;
      this.lang1code = saveResult.data.lang1code;
      this.lang2enabled = saveResult.data.lang2enabled;
      this.lang2name = saveResult.data.lang2name;
      this.lang2code = saveResult.data.lang2code;
      this.lang1currency = saveResult.data.lang1currency;
      this.lang2currency = saveResult.data.lang2currency;
      this.defaulttax = saveResult.data.defaulttax;
      this.externalconfig = saveResult.data.externalconfig;
      this.videocalls = saveResult.data.videocalls;
      this.maxtimepre = saveResult.data.maxtimepre;
      this.maxtimempi = saveResult.data.maxtimempi;
      this.maxtimejp = saveResult.data.maxtimejp;
      this.maxtimeauth = saveResult.data.maxtimeauth;
      this.maxtimeqi = saveResult.data.maxtimeqi;
      this.maxtimeprejp = saveResult.data.maxtimeprejp;
      this.maxtimepreauth = saveResult.data.maxtimepreauth;
      this.cacheSettings();
    } else {
      this.helper.notify('Could not save the updated settings', 'danger');
      return;
    }

    let failed = false;
    if (this.newLogo !== undefined) {
      const { data, error } = await this.supa.supabase.storage
                .from('internaldesign')
                .upload('companylogo.png', this.newLogo, {contentType: 'image/png', upsert: true, cacheControl: '0'});
      if (error) {
        this.helper.notify('Settings were saved, but the logo could not be processed', 'warning');
        console.log(error);
        failed = true;
      }
      this.newLogo = undefined;
    }
    if (!failed) {
      this.helper.notify('Settings were saved', 'success');
    }
    loading.dismiss();
    this.loadingDone = true;
  }

  uploadDesktopPicture(event, isReset=false) {
    if (isReset) {
      // eslint-disable-next-line max-len
      this.newLogo = decode('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');
      this.helper.notify('Press save to store the new logo.', 'primary');
      return;
    }
    if (event.target.files === undefined){
      this.helper.notify('Please upload a file', 'warning');
      return;
    }
    if (event.target.files[0] === undefined){
      this.helper.notify('Please upload a file', 'warning');
      return;
    }
    if (event.target.files[0].type === undefined){
      this.helper.notify('Please upload a file', 'warning');
      return;
    }
    if (!event.target.files[0].type.includes('image')){
      this.helper.notify('Please upload an image', 'warning');
      return;
    }
    if (event.target.files[0].size === undefined){
      this.helper.notify('Please upload an image', 'warning');
      return;
    }
    if (event.target.files[0].size / 1024 > 2048){
      this.helper.notify('The image should be smaller then 2MB', 'warning');
      return;
    }

    this.helper.notify('Press save to store the new logo.', 'primary');
    this.newLogo = event.target.files[0];
  }

  async loadData() {
    const settings = await this.supa.Settings();
    console.log(settings);

    this.id = settings.id;
    this.reddays = settings.reddays;
    this.amberdays = settings.amberdays;
    this.lang1name = settings.lang1name;
    this.lang1code = settings.lang1code;
    this.lang2enabled = settings.lang2enabled;
    this.lang2name = settings.lang2name;
    this.lang2code = settings.lang2code;
    this.lang1currency = settings.lang1currency;
    this.lang2currency = settings.lang2currency;
    this.defaulttax = settings.defaulttax;
    this.externalconfig = settings.externalconfig;
    this.videocalls = settings.videocalls;
    this.maxtimepre = settings.maxtimepre;
    this.maxtimempi = settings.maxtimempi;
    this.maxtimejp = settings.maxtimejp;
    this.maxtimeauth = settings.maxtimeauth;
    this.maxtimeqi = settings.maxtimeqi;
    this.maxtimeprejp = settings.maxtimeprejp;
    this.maxtimepreauth = settings.maxtimepreauth;

    this.loadingDone = true;
  }
}

export interface ExternalConfig {
  id: number;
  name: string;
  data: any;
  logo: string;
}
